import bugsnagFactory from "bugsnag-js";

let client;

try {
  client = bugsnagFactory({
    apiKey: "NOT_CONFIGURED",
    autoBreadcrumbs: false,
    autoCaptureSessions: false,
  });
} catch (e) {
  // Bugsnag init failed – provide no-op fallback
  client = null;
}

const Bugsnag = {
  notify: (...args) => {
    if (client && typeof client.notify === "function") {
      client.notify(...args);
    } else {
      console.warn(
        "Bugsnag.notify called but client not initialized:",
        ...args,
      );
    }
  },
  set user(val) {
    if (client) {
      client.user = val;
    }
  },
  get user() {
    return client ? client.user : null;
  },
};

export default Bugsnag;
